// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__VORCe","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3d1M2"};